import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { SetupEAuthorizationComponent } from './container/setup-eAuthorization.component';
import { AccountInfoModule } from '../account-info-header/account-info.module';
import { EAuthorizationPageComponent } from './components/eAuthorization-page/eAuthorization-page.component';
import { SharedModule } from '../shared/shared.module';
import { StoreModule } from '@ngrx/store';
import * as fromSetupEAuthorization from './reducers';
import { EffectsModule } from '@ngrx/effects';
import { EAuthorizationEffects } from './effects/eAuthorization.effects';
import { CommonModule } from '@angular/common';

const COMPONENTS = [
    EAuthorizationPageComponent
]

const CONTAINERS = [
    SetupEAuthorizationComponent
]

@NgModule({
    declarations: [COMPONENTS, CONTAINERS],
    imports: [
        CommonModule,
        AccountInfoModule,
        SharedModule,
        StoreModule.forFeature(
          fromSetupEAuthorization.setupEAuthorizationFeatureKey,
          fromSetupEAuthorization.reducers 
        ),
        EffectsModule.forFeature([
            EAuthorizationEffects
        ]),
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    exports: [SetupEAuthorizationComponent]
})
export class SetupEAuthorizationModule { }